module.exports = __webpack_public_path__ + "static/media/fotovibez2.ce8ff265.jpg";